import { Button, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

// `&&` doubles the generated class selector so this wins over the variant's own
// background-color regardless of emotion's style-insertion order.
export const ConnectBankButton = styled(Button)`
  && {
    background-color: ${Color.White};

    &:hover {
      background-color: ${Color.Grey100};
    }
  }
`

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: ${Spacing.S16};
  justify-content: space-between;
  padding: ${Spacing.S12} ${Spacing.S24};
  background-color: ${Color.Lavender100};
`

export const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
`
